<div class="recent-activity-page">
  <workspace-breadcrumb />
  <div class="recent-activity-page__date-filters">
    <div class="recent-activity-page__date-row">
      <korviu-date-picker
        class="flex-1"
        [control]="startDateControl"
        [label]="'profile.startDate' | translate"
        [disabledDate]="disableStartDate"
        mode="date"
      />
      <korviu-date-picker
        class="flex-1"
        [control]="endDateControl"
        [label]="'profile.endDate' | translate"
        [disabledDate]="disableEndDate"
        mode="date"
      />
    </div>
  </div>
  <korviu-list #activityList [config]="listConfig" />
  <div class="recent-activity-page__help-text">
    {{ 'profile.wereHereHelpIfYouHaveAnyIssues' | translate }}
  </div>
  <korviu-button class="w-full" type="submit" color="tertiary" (onclick)="showContactUsForm()">
    {{ 'faq.contact-help-header' | translate }}
  </korviu-button>
</div>
